import {
	useDecisionMakerProfilePageData,
	useDecisionMakerProfilePageFcm,
} from 'src/app/pages/decisionMakerProfile/pageContext';

export function useResponsivenessScoreEnabled(): boolean {
	const {
		dmProfileRedesign: { profileCard: profileCardEnabled, responsivenessScore: responsivenessScoreEnabled },
	} = useDecisionMakerProfilePageFcm();

	const { responsivenessData: data } = useDecisionMakerProfilePageData();

	const dmHasResponsivenessData = data.responsivenessScore !== null && data.isVisible;

	return profileCardEnabled && !!responsivenessScoreEnabled && dmHasResponsivenessData;
}
